// src/pages/Index.js

import { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import {

  heading,
  headingMobile,
  nonNavButtonStyle,
  paragraph,
  paragraphMobile,
} from "../help/Utils";

import useIsMobile from "../hooks/useIsMobile";

import logo from "../assets/logo.svg";
// import HeroBanner from "../assets/hero-banner.png";



const Index = () => {
  const isMobile = useIsMobile(); // Determine if the viewport is mobile/tablet


  // AOS Initialization
  useEffect(() => {
    AOS.init({
      duration: 500,
      once: true,
      mirror: false,
      offset: 120,
      easing: "ease-in-out",
      disable: window.innerWidth < 768,
    });

    const handleResize = () => {
      AOS.refresh();
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

 

  return (
    <div className="">
      {/* First Container: Banner Section */}
      <div
        className="firstContainer flex flex-col md:flex-row justify-between relative gap-3 bg-gray-50"
        data-aos="fade-up"
      >
        {/* Text Section */}
        <div
          className="pl-2 md:pl-28 w-full md:w-[49%] relative z-10 pb-10 md:pb-[130px]"
          data-aos="fade-right"
        >
          <h1
            className={`mt-10 text-center md:text-start `}
            style={isMobile ? headingMobile : heading}
          >
           Let's see if you're eligible to apply for U.S. citizenship.
          </h1>

          {/* Image for Mobile/Tablets */}
          <div className="mt-5 mb-10 md:hidden" data-aos="fade-left">
            <img
              src={logo}
              className="w-full mt-8 relative z-10 rounded-2xl"
              alt="Dashboard Screenshot"
            />
          </div>

          <h3
            className={`mt-5 mb-10 text-center md:text-start ${
              isMobile ? "" : ""
            }`}
            style={isMobile ? paragraphMobile : paragraph}
          >
            Please answer a few quick questions to find out.
          </h3>
          {/* Sign Up Button */}
          <div
            className={`flex ${isMobile ? "justify-center" : "justify-start"}`}
          >
            <Link to="/signup">
              <button style={nonNavButtonStyle} className="">
                Start Now
              </button>
            </Link>
          </div>
        </div>

        {/* Image for Desktop */}
        <div
          className="hidden md:block w-1/2 relative ml-10"
          data-aos="fade-left"
        >
          {/* <img
            src={HeroBanner}
            className="w-[90%] mt-8 relative z-10 rounded-2xl"
            alt="Dashboard Screenshot"
          /> */}
        </div>

        {/* Background Banner Image */}
        <img
          src={logo}
          className="absolute z-0 w-full opacity-10 bottom-0"
          alt="Background Banner"
        />
      </div>
    </div>
  );
};

export default Index;